import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { hasValue } from "./commonFns";

const ConfirmationPopup = ({ isOpen, handleConfirmationPopup, bodyText }) => {
  return (
    <>
      <Modal
        size="md"
        isOpen={isOpen}
        toggle={() => handleConfirmationPopup(false)}
      >
        <ModalHeader toggle={() => handleConfirmationPopup(false)}>
          {"Confirmation"}
        </ModalHeader>
        <ModalBody>
          <Label className="center-align">
            {hasValue(bodyText)
              ? bodyText
              : "Are you sure, do you want to continue?"}
          </Label>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              handleConfirmationPopup(true);
            }}
          >
            Continue
          </Button>
          <Button onClick={() => handleConfirmationPopup(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ConfirmationPopup;
